import { NewFeatureNotification } from '@ardoq/status-ui';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { Link } from '@ardoq/link';
import { IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { colors } from '@ardoq/design-tokens';
import { type I18nLocale, t } from '@ardoq/i18n';
import { ReactElement, ReactNode } from 'react';

export type NewFeatureNotificationProps = {
  show: boolean;
  onClose: VoidFunction;
  i18nLocale?: I18nLocale;
} & (
  | {
      notificationMessage: string | ReactNode;
      helpLink?: {
        href: string;
        label: string;
      };
    }
  | { customContent: ReactElement }
);

export const ActionableNewFeatureNotification = ({
  show,
  onClose,
  i18nLocale = {},
  ...props
}: NewFeatureNotificationProps) => {
  if (!show) return null;

  return (
    <NewFeatureNotification>
      <FlexBox align="center" justify="space-between">
        {'customContent' in props ? (
          props.customContent
        ) : (
          <Text variant="text2">
            {props.notificationMessage}
            {props.helpLink && (
              <Link
                href={props.helpLink.href}
                hideIcon
                target="_blank"
                style={{ marginLeft: 4 }}
                typography="text2"
              >
                {props.helpLink.label}
              </Link>
            )}
          </Text>
        )}
        <IconButton
          label={t(
            i18nLocale,
            'snowflakes:actionableNewFeatureNotification.closeLabel',
            'Close'
          )}
          onClick={onClose}
          iconName={IconName.CLOSE}
          iconColor={colors.grey500}
        />
      </FlexBox>
    </NewFeatureNotification>
  );
};
